import { durationText } from './timeline-duration.policy';

export type VarianceTone = 'late' | 'early' | 'on_time';

export interface VarianceLabel {
  text: string;
  tone: VarianceTone;
}

/** Within a minute of the plan reads as on time; a person cannot tell the difference and neither can the plan's own rounded times. */
const ON_TIME_SECONDS = 59;

/** The words for a variance, so lateness is read and never only coloured. Null when there is no figure to show. */
export function varianceLabel(seconds: number | null): VarianceLabel | null {
  if (seconds === null) return null;
  if (Math.abs(seconds) <= ON_TIME_SECONDS) return { text: 'on time', tone: 'on_time' };
  return seconds > 0 ? { text: `${durationText(seconds)} late`, tone: 'late' } : { text: `${durationText(seconds)} early`, tone: 'early' };
}
